import React from "react";
import styles from "./button.module.css";
import clsx from "clsx";

const Button = ({ children, isSmall, click }) => {
  return (
    <button
      className={clsx({
        [styles.button]: !isSmall,
        [styles.buttonSmall]: isSmall,
      })}
      onClick={() => {
        click();
      }}
    >
      {children}
    </button>
  );
};

export default Button;
